import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";

const OutOfStockPage = () => {
  const [outOfStockItems, setOutOfStockItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOutOfStockItems();
  }, []);

  const fetchOutOfStockItems = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        "https://backend.lehuluet.com/api/items/out-of-stock"
      );
      setOutOfStockItems(response.data.data || []);
      toast.success(
        response.data.message || "Out of stock items fetched successfully"
      );
    } catch (error) {
      setOutOfStockItems([]);
      toast.error(
        error.response?.data?.message || "Failed to fetch out of stock items"
      );
    } finally {
      setLoading(false);
    }
  };

  const exportToCSV = () => {
    if (!outOfStockItems.length) return;

    const headers = [
      "Brand",
      "Size",
      "Ampere/Unique size",
      "Position",
      "Origin",
      "Category",
      "Branch",
      "Added By",
      "Quantity",
      "Date Added",
    ];
    const rows = outOfStockItems.map((item) => [
      item.brand || "",
      item.category?.name || "",
      item.size || "",
      item.category?.name?.toLowerCase() === "battery"
        ? item.ampere || ""
        : item.uniquesize || "",
      item.position || "",
      item.origin || "",
      item.branch || "",
      item.user?.name || "N/A",
      item.quantity || "0",
      new Date(item.created_at).toLocaleDateString(),
    ]);

    const csvContent = [
      headers.join(","),
      ...rows.map((row) => row.map((cell) => `"${cell}"`).join(",")),
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "out_of_stock_items.csv";
    link.click();
    URL.revokeObjectURL(link.href);
  };

  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-6">
      <h1 className="text-3xl text-teal-700 font-bold mb-6 text-center">
        Out of Stock Items
      </h1>
      <div className="bg-white rounded-lg shadow-md p-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold">Out of Stock Items</h2>
          {outOfStockItems.length > 0 && (
            <button
              onClick={exportToCSV}
              className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600 transition"
            >
              Export to CSV
            </button>
          )}
        </div>
        {loading ? (
          <div className="flex justify-center items-center py-8">
            <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-teal-500"></div>
          </div>
        ) : outOfStockItems.length > 0 ? (
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200 text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Brand
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Category
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Size
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Ampere/Unique size
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Position
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Origin
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Branch
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Added By
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Quantity
                  </th>
                  <th className="px-4 py-3 text-left font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap">
                    Date Added
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {outOfStockItems.map((item) => (
                  <tr
                    key={item._id}
                    className="hover:bg-teal-50 transition-all duration-200"
                  >
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.brand || "-"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.category?.name || "-"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.size || "-"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.category?.name?.toLowerCase() === "battery"
                        ? item.ampere || "-"
                        : item.uniquesize || "-"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.position || "-"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.origin || "-"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.branch || "-"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {item.user?.name || "N/A"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap text-red-600 font-semibold">
                      {item.quantity || "0"}
                    </td>
                    <td className="px-4 py-2 whitespace-nowrap">
                      {new Date(item.created_at).toLocaleDateString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="mt-4 text-gray-600">
              Total out of stock items: {outOfStockItems.length}
            </div>
          </div>
        ) : (
          <div className="text-center py-4 text-gray-500">
            No out of stock items found.
          </div>
        )}
      </div>
      <ToastContainer position="top-right" autoClose={3000} />
    </div>
  );
};

export default OutOfStockPage;
